/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-15 08:18:35 */

const Keys = {
  firstName: { label: 'firstName.label', placeholder: 'firstName.placeholder' },
  lastName: { label: 'lastName.label', placeholder: 'lastName.placeholder' },
  email: { label: 'email.label', placeholder: 'email.placeholder' },
  requiredField: 'requiredField',
  emailError: 'emailError',
  termsAndConditionsError: 'termsAndConditionsError',
  signUp: 'signUp'
}; export default Keys;